import {
  Company,
  Enrolment,
  RateRequest,
} from '@kanda-libs/ks-frontend-services';

import { Dictionary } from '@reduxjs/toolkit';

export type CombinedEnrolment = {
  id: string;
  rate_request: RateRequest;
  company?: Company;
};

export const combineEnrolmentData = (
  enrolments: Enrolment[],
  companies: Dictionary<Company>,
): CombinedEnrolment[] =>
  enrolments.map((enrolment) => ({
    id: enrolment.id,
    rate_request: enrolment.rate_request,
    company: companies?.[enrolment.id],
  }));
